import messages from './exchange-rate-download-form-lang.json';
import tabbable from '../../../common/js/tabbable/tabbable';
import { required } from 'vuelidate/lib/validators';
import { date } from '../../../common/js/validators';
import dateLessThanOrEqual from '../../../common/js/validators/date-less-than-or-equal';
import moment from 'moment';
import { BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';
import eventBus from '../../../common/js/event-bus/event-bus';
import { saveAs } from 'file-saver';
import axios from 'axios';
import VueDatepicker from '@ui-common/vue-datepicker';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueCheckbox from '@ui-common/vue-checkbox';

export default {
	data() {
		return {
			downloadPopupVisible: null,
			inProgress: null,
			model: {
				from: null,
				to: null,
				downloadType: 'xls',
				currencies: []
			}
		};
	},
	mixins: [tabbable],
	props: {
		date: {
			required: true
		},
		currencies: {
			required: true
		}
	},
	components: {
		VueDatepicker,
		VueErrorMessage,
		VueRadioGroup,
		VueCheckbox
	},
	i18n: { messages },
	watch: {
		date(val) {
			const toDate = moment(val, BACKEND_DATE_FORMAT);
			this.model.to = val;
			this.model.from = toDate.subtract(1, 'months').format(BACKEND_DATE_FORMAT);
		},
		downloadPopupVisible(val) {
			eventBus.$emit('toggleAriaHidden', val);
			if (!val) {
				this.$nextTick(() => {
					eventBus.$emit('focusDownload', val);
				});
				document.body.classList.remove('modal-open');
			} else {
				document.body.classList.add('modal-open');
			}
		}
	},
	validations() {
		return {
			model: {
				from: {
					required,
					date: date(BACKEND_DATE_FORMAT),
					dateLessThanOrEqual: dateLessThanOrEqual(BACKEND_DATE_FORMAT, this.model.to)
				},
				to: {
					required,
					date: date(BACKEND_DATE_FORMAT)
				},
				currencies: {
					required
				}
			}
		};
	},
	computed: {
		isAllSelected() {
			return this.currencies && this.currencies.length == this.model.currencies.length;
		},
		isAnySelected() {
			return this.model.currencies.length;
		},
		downloadUrl() {
			const language = this.$i18n.locale.toUpperCase();
			const serverFrom = moment(this.model.from).format(BACKEND_DATE_FORMAT);
			const serverTo = moment(this.model.to).format(BACKEND_DATE_FORMAT);
			return (
				`/apps/exchangerate/api/downloads/${this.model.downloadType}/${serverFrom}/${serverTo}` +
				`?currencies=${this.model.currencies}&lang=${language}`
			);
		},
		today() {
			return moment().format(BACKEND_DATE_FORMAT);
		},
		yesterday() {
			return moment().subtract(1, 'day').format(BACKEND_DATE_FORMAT);
		}
	},
	methods: {
		selectAll() {
			this.model.currencies = this.currencies.map((item) => item.currencyCode);
		},
		deselectAll() {
			this.model.currencies = [];
		},
		isChecked(currency) {
			return this.model.currencies.indexOf(currency.currencyCode) != -1;
		},
		closePopup() {
			this.$closeModal('exchange-rate-download-modal');
		},
		download() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.inProgress = true;
				axios({
					method: 'get',
					url: this.downloadUrl,
					responseType: 'blob'
				}).then((response) => {
					const filename = response.headers.filename;
					const blob = new Blob([response.data]);
					const filesaver = saveAs(blob, filename);
					// IE hack: doesn't have onwriteend callback pfhh
					if (navigator.msSaveOrOpenBlob) {
						this.inProgress = false;
					} else {
						filesaver.onwriteend = () => {
							this.inProgress = false;
						};
					}
				});
			}
		}
	},
	created() {
		eventBus.$on('modal-opened', (modalId) => {
			if (modalId == 'exchange-rate-download-modal') {
				this.downloadPopupVisible = true;
				this.selectAll();
			}
		});
	}
};
